import React, { Children, cloneElement, isValidElement, useEffect, useState, } from 'react';
import DetectOutsideClick from '@anwb/detect-outside-click';
import { DisableScroll } from '@anwb/disable-scrolling';
import { Portal } from '@anwb/portal';
import { PopoverBody } from './PopoverBody';
import PopoverContent from './PopoverContent';
import { PopoverContext } from './PopoverContext';
import { PopoverFooter } from './PopoverFooter';
import { PopoverHeader } from './PopoverHeader';
import { PopoverTrigger } from './PopoverTrigger';
import { PopoverContainer, PopoverWrapper } from './styles/popover.styled';
const getPopoverElementType = (popoverElement) => isValidElement(popoverElement) &&
    typeof popoverElement.type !== 'string' &&
    popoverElement.type.POPOVER_ELEMENT;
const getPopoverComponents = (children) => Children.toArray(children).reduce((popoverChildrenMap, child) => {
    const popoverElementType = getPopoverElementType(child);
    if (popoverElementType) {
        // eslint-disable-next-line no-param-reassign
        popoverChildrenMap[popoverElementType] = child;
    }
    return popoverChildrenMap;
}, { trigger: null, header: null, body: null, footer: null, wrapper: null });
const OptionalContentWrapper = ({ wrapper, children, }) => 
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
isValidElement(wrapper) ? cloneElement(wrapper, Object.assign(Object.assign({}, wrapper.props), { children })) : React.createElement(React.Fragment, null, children);
export const Popover = ({ children, direction = 'down', onClose, onOpen, open = false, offset, handlerOpenState, contentWrapper, dataTest = 'popover', }) => {
    const [openPopover, setOpenPopover] = useState(open);
    const [contentTop, setContentTop] = useState(0);
    const [contentBottom, setContentBottom] = useState(0);
    const [triggerLeft, setTriggerLeft] = useState(0);
    const [triggerRight, setTriggerRight] = useState(0);
    const [showFade, setShowFade] = useState(false);
    useEffect(() => {
        setOpenPopover(open);
    }, [open]);
    useEffect(() => {
        if (handlerOpenState)
            handlerOpenState(openPopover);
        if (openPopover && onOpen) {
            onOpen();
        }
    }, [openPopover]);
    const { trigger, header, body, footer } = getPopoverComponents(children);
    return (React.createElement(PopoverContext.Provider, { value: {
            direction,
            openPopover,
            contentTop,
            contentBottom,
            triggerLeft,
            triggerRight,
            showFade,
            setOpenPopover,
            setContentTop,
            setContentBottom,
            setTriggerLeft,
            setTriggerRight,
            setShowFade,
            offset,
        } },
        React.createElement(PopoverContainer, { "data-test": dataTest },
            trigger,
            openPopover && (React.createElement(Portal, { id: "popover", className: "PONCHO-popover-container" },
                React.createElement(React.Fragment, null,
                    React.createElement(DisableScroll, null),
                    React.createElement(PopoverWrapper, null,
                        React.createElement(DetectOutsideClick, { onClickOutside: () => {
                                if (onClose) {
                                    onClose();
                                }
                                setOpenPopover(false);
                            } },
                            React.createElement(PopoverContent, { dataTest: `${dataTest}-content` },
                                React.createElement(OptionalContentWrapper, { wrapper: contentWrapper },
                                    header,
                                    body,
                                    footer))))))))));
};
Popover.Trigger = PopoverTrigger;
Popover.Header = PopoverHeader;
Popover.Body = PopoverBody;
Popover.Footer = PopoverFooter;
export default Popover;
//# sourceMappingURL=Popover.js.map